<template>
    <div>
        <div class="box1000">
            <div class="box1001">
                <div class="box1002" style="float: left; margin-left: 0">
                    <router-link to="/user" v-if="username" style="color: #2B9A34;">{{ username.keLongNumber }}
                    </router-link><span v-else>您好</span>，欢迎来到科隆化学商城！
                </div>
                <div class="box1003" style="width: 70%">
                    <!-- <a :href="description ? description.website : '/'" target="_blank"> -->
                    <!-- <a href="http://www.chronchem.com/cn/" target="_blank">
                        <div class="box1002" style="padding: 0"><img src="../assets/home1.png" style="width: 14px; float: left; margin-top: 10px; margin-right: 5px" alt="" /><span style="float: left">前往官网</span></div>
                    </a> -->
                    <div class="box1002">
                        <img src="../assets/phone1.png"
                            style="width: 14px; float: left; margin-top: 10px; margin-right: 5px" alt="" />
                        <span style="float: left">
                            {{ description ? description.tel : '' }}
                        </span>
                    </div>
                    <div class="box1002">
                        <img src="../assets/qq1.png"
                            style="width: 14px; float: left; margin-top: 10px; margin-right: 5px" alt="" /><span
                            style="float: left">
                            {{ description ? description.qq : '' }}
                        </span>
                    </div>
                    <div class="box1002" style="cursor: pointer;" @click="to('/message')">消息（{{ message_length }}）</div>
                    <a v-if="username" href="/m/" class="box1002">平台管理</a>
                    <a v-if="username" href="/s/" class="box1002">卖家中心</a>
                    <div>
                        <div class="box1002">
                            <div style="position: relative" class="" @mouseover="popHuiyuanCodess()"
                                @mouseout="popHuiyuanCode = false">
                                <span style="float: left;cursor: pointer;" @click="to('/user')">会员中心</span>
                                <a-icon style="float: left; margin-left: 5px; margin-top: 12px" type="caret-down" />
                                <div v-show="popHuiyuanCode"
                                    style="z-index: 99999; width: 185px; height: 100px; background: #ffffff; border: 1px solid #e4e4e4; position: absolute; top: 35px; left: -105px">
                                    <div style="width: 50%; float: left">
                                        <router-link to="/enterprise_info">
                                            <div class="user_pop_view_txt">企业信息</div>
                                        </router-link>
                                        <router-link to="/qualifications">
                                            <div class="user_pop_view_txt">我的资质</div>
                                        </router-link>
                                        <router-link to="/credit_y">
                                            <div class="user_pop_view_txt">授信建档</div>
                                        </router-link>
                                    </div>
                                    <div style="width: 50%; float: left">
                                        <router-link to="/user_info">
                                            <div class="user_pop_view_txt">个人信息</div>
                                        </router-link>
                                        <router-link to="/account_security">
                                            <div class="user_pop_view_txt">账户安全</div>
                                        </router-link>
                                        <div class="user_pop_view_txt pointer" @click.prevent="tuichudenglu">退出登录</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <router-link to="/login?id=1" v-if="!username">
                        <div class="box1002">免费注册</div>
                    </router-link>
                    <div v-if="!username" @click="to_login" class="box1002"
                        style="color: #2b9a34;float: right;cursor: pointer;text-align: right;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                        请登录</div>
                </div>
            </div>
        </div>

        <div style="width: 100%; border-bottom: 2px solid #2b9a34">
            <div class="box1004" style="position: relative">
                <div style=" width: 100%">
                    <router-link to="/"><img src="../assets/logo1.png" class="box1005" alt="" /> </router-link>
                    <div style="margin-top: 3%; margin-left: 70px;  float: left">
                        <div class="recombination" :class="showClassify ? 'show-classify' : ''">
                            <div class="classify" @click="showClassify = !showClassify">
                                {{ classifyList[classify].title }}
                                <img src="../assets/arrow  down@2x.png" alt="" />
                            </div>
                            <input @keyup.enter="onSubmit" v-model="index_search" type="text" class="head_input"
                                placeholder="请输入CAS号、分子式、品牌、品名" autocomplete="off" />
                            <div class="head_input_icon" @click="onSubmit">
                                <a-icon type="search" style="color: #fff" />
                            </div>
                            <div class="classify-list">
                                <div class="item" :class="classify == i ? 'green' : ''"
                                    v-for="(item, i) in classifyList" :key="item.key" @click="
    classify = i;
showClassify = false;
                                    ">
                                    {{ item.title }}
                                </div>
                            </div>
                        </div>

                        <div
                            style="overflow: hidden; margin-top: 2%; width: 420px;white-space: nowrap;text-overflow: ellipsis;height: 28px;">
                            <div class="box1006" style="margin-left: 0; color: #f24246">热门搜索</div>
                            <div @click="to_goods_page(item)" v-for="(item, index) in index_hotSearch_data" :key="index"
                                class=" box1006">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                    <div class="box1003" style="width: 42%; margin-top: 3%">
                        <!-- 客户要求先隐藏小程序二维码 -->
                        <!-- <div class="box1002 box1007" style="margin-top: -4%; width: 130px">
                            <img :src="img_qrcode" style="width: 72px; height: 72px; float: left; margin-left: 10px; margin-top: 10px" alt="" />
                            <div class="gzh_erweima_txt">小程序商城</div>
                        </div> -->
                        <div class="box1008 pointer" style="margin-right: 20px" @click="tiaozhuan">我的订单</div>
                        <div class="box1008 pointer" @click="to('/collection')">收藏夹</div>
                        <div class="box1008 pointer" style="text-align: center; margin: 0" @click="to('/shop_cart')">
                            <div style="position: relative; float: left">
                                <a-icon style="float: left; margin-right: 20px; font-size: 20px; margin-top: 10px"
                                    type="shopping-cart" />
                                <span class="catr_num">{{ headerCartCount }}</span>
                            </div>
                            <span style="float: left">我的购物车</span>
                        </div>
                    </div>
                </div>
                <div style="height: 50px; width: 100%; position: absolute; bottom: 0">
                    <div class="box1009">
                        <img src="../assets/index/category.png" />
                        <p v-if="menuCode" class="box1013"
                            style="display: inline-block;height: 34px;width: 220px; top:0px; background: #2b9a34;border-left:10px solid #1e6924;border-right:10px solid #1e6924">
                        </p>
                        <div class="aside-menu inner">
                            <div v-if="menuCode" class="box1013 menu-content innerbox"
                                style="height: 415px;top: 67px;background-color:#289031" id="menu_content">
                                <!-- <div style="overflow: hidden; padding: 4%" v-for="(item, index) in allAvailableTree_list" :key="index" class="box1015">
                                    <div class="box1013" style="margin-top: 2%">
                                        <span class="left_fenlei_title" @click="yijifenlei(item.id)">{{ item.name }}</span>
                                        <a-icon type="right" style="float: right" />
                                    </div>
                                    <div class="box1013 left_fenlei_txt" style="margin-top: 1.13%" @click="erjifenlei(item.id)">
                                        {{ item.children && item.children.length ? item.children[0].name : '' }}
                                    </div>
                                </div> -->
                                <div @mouseover="_popMenuCode(1, index)" @mouseout="_popMenuCode(0, index)"
                                    style="overflow: hidden; padding: 4%" v-for="(item, index) in allAvailableTree_list"
                                    :key="index" class="box1015">
                                    <div class="box1013" style="margin-top: 2%">
                                        <span class="left_fenlei_title" @click="yijifenlei(item.id)">{{ item.name
                                        }}</span>
                                    </div>
                                    <div class="box1013 left_fenlei_txt" style="margin-top: 1.13%"
                                        @click="erjifenlei(item.id)">
                                        <template v-for="(i, index) in item.children">
                                            <span v-if="index < 2" :key="i.id">{{ i.name }}</span>
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <div v-show="popMenuCode" class="pop_view_root" @mouseover="popMenuCode = true"
                                @mouseout="popMenuCode = false">
                                <!-- <div style="overflow: hidden" :key="index" v-for="(item,index) in allAvailableTree_list"> -->
                                <div style="overflow: hidden">
                                    <div class="tanchu_txt" style="padding-right: 20px">
                                        <template
                                            v-if="allAvailableTree_list[erji_index] && allAvailableTree_list[erji_index].children && allAvailableTree_list[erji_index].children.length">
                                            <div v-for="(item1, a) in allAvailableTree_list[erji_index].children"
                                                :key="a" style="margin-left: 20px; display: flex" class="tanchu_txt1">
                                                <div style="min-width: 10em">{{ item1.name }} ></div>
                                                <div v-if="item1 && item1.children && item1.children.length">
                                                    <div @click="sanjifenlei(item2.id)"
                                                        v-for="(item2, b) in item1.children" :key="b"
                                                        class="tanchu_txt tanchu_txt1"
                                                        style="font-size: 12px; float: left; margin-left: 20px;font-weight: normal;">
                                                        {{ item2.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <!-- </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="box1010">
                        <router-link to="/">
                            <div :class="['box1011', top_index == 0 ? 'gaoliang' : '']" style="margin-left: 0">首页</div>
                        </router-link>
                        <router-link to="/goods_type">
                            <div class="box1011" :class="['box1011', top_index == 1 ? 'gaoliang' : '']">产品目录</div>
                        </router-link>
                        <!-- <div class="box1011">最新活动</div> -->
                        <router-link to="/customized">
                            <div class="box1011" :class="['box1011', top_index == 2 ? 'gaoliang' : '']">定制</div>
                        </router-link>
                        <router-link to="/purchase">
                            <div class="box1011" :class="['box1011', top_index == 3 ? 'gaoliang' : '']">批量采购</div>
                        </router-link>
                        <router-link to="/download">
                            <div class="box1011" :class="['box1011', top_index == 5 ? 'gaoliang' : '']">文档下载</div>
                        </router-link>

                        <router-link to="/news">
                            <div class="box1011" :class="['box1011', top_index == 4 ? 'gaoliang' : '']">科隆资讯</div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div style="background: #f2f2f2; width: 100%">
            <breadcrumb v-if="crumbsShow" style="width: 1200px; margin: auto; padding: 12px 0" />
        </div>
    </div>
</template>

<script>
const classifyList = [
    {
        title: '全部分类',
        key: 'all'
    },
    {
        title: '品名',
        key: 'name'
    },
    {
        title: 'CAS号',
        key: 'casNum'
    },
    {
        title: '货号',
        key: 'skuSn'
    },
    {
        title: '别名',
        key: 'alias'
    },
    {
        title: '分子式',
        key: 'molecularFormula'
    }
];
import breadcrumb from '../public/Breadcrumb';
export default {
    name: 'Head',
    inject: ['reload'],
    props: [
        'menuCode', //左侧菜单是否显示
        'crumbsShow', //面包屑是否显示
        'top_index', //顶部激活的选项
        'cart_count'
    ],
    components: {
        breadcrumb
    },
    data() {
        return {
            classifyList,
            classify: 0,
            showClassify: false,
            description: null,
            erji_index: 0, //展开二级分类索引
            index_search: '', //搜索文字
            popMenuCode: false, //是否显示左侧菜单
            popHuiyuanCode: false, //是否显示会员 hover
            username: '', //会员信息
            headerCartCount: 0, //购物车数量
            index_hotSearch_data: [], //热门搜索
            allAvailableTree_list: [], //商品分类
            message_length: 0, //顶部未读消息数量
            img_qrcode: '',
            is_login: false
        };
    },
    beforeMount() {
        this.api.get_public_Info().then(res => {
            if (res.data && res.data.description) {
                let other_config = res.data.description;
                if (other_config) {
                    other_config = JSON.parse(other_config);
                    this.img_qrcode = `/api/file/preview/${other_config.miniProgram}`;
                }
            }
        });
    },
    watch: {
        cart_count() {
            this.updateCartCountFun();
        },
        updateCartCount() {
            this.updateCartCountFun();
        }
    },
    computed: {
        updateCartCount() {
            return this.$store.getters.updateCartCount;
        }
    },
    created() {
        if (window.localStorage.uuid) {
            this.is_login = true;
            this.api.user_info().then(res => {
                if (res.ok) {
                    this.username = res.data;
                }
            });
        }
        if (localStorage.username) {
            this.updateCartCountFun();
            this.get_phone();
            this.get();
        }
        if (this.$route.query.search) {
            this.index_search = this.$route.query.search;
        }
        if (this.$route.query.typeAccuracy) {
            this.classifyList.forEach((element, index) => {
                if (element.key == this.$route.query.typeAccuracy) {
                    this.classify = index;
                }
            });
        }
        this.index_hotSearch();
        this.get_allAvailableTree();
        this._getInfoFun();
        this.system_message_unreadCount();
    },
    methods: {
        tiaozhuan() {
            if (localStorage.getItem('uuid')) {
                this.$router.push('/order');
                // this.$router.push('/control_over_invoices')
            } else {
                this.$confirm({
                    title: '请先登录',
                    onOk: () => this.$router.push('/login')
                });
            }
        },
        //是否支付跳转
        get() {
            if (window.location.href.split('&')[9]) {
                const id = window.location.href.split('&')[0];
                const ids = id.split('=')[1].split('/')[0];
                // console.log(ids);
                const url = window.location.href.split('&')[9];
                // console.log(url);
                const urls = url.split('=')[1];
                // console.log(urls);
                if (urls == '2021001163638207') {
                    this.$router.push({ name: 'pay_successful', query: { uuid: ids } });
                }
            }
        },
        // 获取手机号
        get_phone() {
            this.api.get_phone().then(res => {
                if (!res.data) {
                    if (this.$route.path !== '/change_tel') {
                        this.$confirm({
                            title: '前去绑定手机',
                            onOk: () => this.$router.push('/change_tel?id=1')
                        });
                    }
                } else {
                    this.api.jiachashiming().then(res => {
                        if (!res.data.realName) {
                            if (this.$route.path !== '/user_info' && this.$route.path !== '/user_info_edit' && this.$route.path !== '/login_password' && this.$route.path !== '/') {
                                this.$confirm({
                                    title: '前去完成用户实名',
                                    onOk: () => this.$router.push('/user_info')
                                });
                            } else {
                            }
                        }
                    });
                }
            });
        },
        to(path) {
            if (window.localStorage.uuid) {
                this.$router.push(path);
            } else {
                this.$confirm({
                    title: '请先登录',
                    onOk: () => this.$router.push('/login')
                });
            }
        },
        popHuiyuanCodess() {
            var that = this;
            var islogin = localStorage.getItem('Access-Token');
            if (islogin) {
                this.popHuiyuanCode = true;
            } else {
                this.popHuiyuanCode = false;
            }
        },
        // 公共配置信息
        _getInfoFun() {
            let other_config = window.sessionStorage.other_config;
            if (other_config) {
                other_config = JSON.parse(other_config);
                this.description = other_config;
            } else {
                this.api.get_public_Info().then(res => {
                    if (res.data && res.data.description) {
                        this.description = JSON.parse(res.data.description);
                    }
                });
            }
        },
        // 触摸一级分类
        _popMenuCode(e, index) {
            this.popMenuCode = e == 0 ? false : true;
            this.erji_index = index;
        },
        // 点击分类跳转
        yijifenlei(e) {
            this.$router.push(`/goods_type?type_id=${e}&type=1`);
        },
        erjifenlei(e) {
            this.$router.push(`/goods_type?type_id=${e}&type=2`);
        },
        sanjifenlei(e) {
            this.$router.push(`/goods_type?type_id=${e}&type=3`);
        },
        // 获取商品分类
        get_allAvailableTree() {
            if (!this.menuCode) return;
            const that = this;
            that.api.get_allAvailableTree().then(res => {
                that.allAvailableTree_list = res.data;
            });
        },
        // 点击热门额搜索
        to_goods_page(e) {
            if (e.name !== this.$route.query.search) {
                this.$router.push('/goods_type?search=' + e.name);
                this.reload();
            }
        },
        // 热门搜索
        index_hotSearch() {
            this.api.index_hotSearch().then(res => {
                if (res.ok) {
                    this.index_hotSearch_data = JSON.parse(res.data.description);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 搜索
        onSubmit() {
            // let index_search = this.index_search.replace(/^\s+|(\s+$)/g, '');
            let index_search = this.index_search.replace(/\s/g, "")
            // let data = this.index_search.replace(/\s/g,"");
            console.log(index_search);
            if (this.classify == 0) {

                window.location.href = '#/goods_type?search=' + encodeURI(index_search);
            } else {
                window.location.href = `#/goods_type?search=${encodeURI(index_search)}&typeAccuracy=${this.classifyList[this.classify].key}`;
            }
            this.$emit('headSearchFun');
        },
        _getSearchParamsFun(item) {
            var svalue = window.location.hash.match(new RegExp('[?&]' + item + '=([^&]*)(&?)', 'i'));
            return svalue ? svalue[1] : svalue;
        },
        //
        to_login() {
            // if (localStorage.username) {
            //     this.$router.push('/user');
            // } else {
            this.$router.push('/login');
            // }
        },
        // 刷新购物车数量
        updateCartCountFun() {
            // 未登录不调用购物车数量的接口
            var newdata = JSON.parse(localStorage.getItem('user_info'))
            if (newdata) {
                this.headerCartCount = 0;
                this.api.get_cart_count().then(res => {
                    this.headerCartCount = res.data;
                })
            } else {
                console.log('未登录不请求购物车数量的接口');
            }
        },
        // 退出登录
        tuichudenglu() {
            const that = this;
            that.$confirm({
                title: '退出登录吗?',
                okText: '确定',
                cancelText: '取消',
                onOk() {
                    localStorage.clear();
                    that.$router.push('/login');
                }
            });
        },
        // 获取未读消息数量
        system_message_unreadCount() {
            if (!window.localStorage.uuid) return;
            this.api.system_message_unreadCount().then(res => {
                if (res.ok) {
                    this.message_length = res.data;
                }
            });
        }
    }
};
</script>

<style scoped>
@import '../css/App.css';
</style>

<style scoped>
.innerbox {
    overflow-x: hidden;
    overflow-y: auto;
    color: #fff;
    height: 100%;
}

/*滚动条样式*/
.innerbox::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 6px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
}

.innerbox::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0); */
    background: #fff;
}

.innerbox::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0); */
    border-radius: 0;
    background: #fff;
}

.menu-content::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 8px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
}

.menu-content::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    /* -webkit-box-shadow: inset 0 0 5px #FFF; */
    background: rgba(255, 255, 255, 0.8);
}

.menu-content::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0); */
    background: rgb(30, 105, 36);
}

.pointer {
    cursor: pointer;
}

.menu-content {
    position: absolute;
    top: 52px;
    display: block;
    width: 220px;
    height: 430px;
    box-shadow: 0px 0px 11px 1px rgba(161, 150, 150, 0.26);
    overflow: auto;
}

.menu-content>p {
    position: sticky;
    top: 0;
    margin: 0;
    width: 100%;
    height: 16px;
    background: #2b9a34;
    border-left: 10px solid rgb(30, 105, 36);
    border-right: 8px solid rgb(30, 105, 36);
}

.menu-content>.box1015 {
    background: #289031;
}

.menu-content>.box1015:hover {
    background: white;
    color: #2b9a34;
}

.box1010,
.box1011 {
    margin-left: 80px;
}

.left_fenlei_title {
    font-size: 14px;
    font-weight: bold;
}

.left_fenlei_txt {
    font-size: 12px;
}

.left_fenlei_txt>span {
    margin-right: 1em;
    white-space: nowrap;
}

.box1001 .box1002 {
    padding: 0;
    margin: 0 10px;
}

.box1001 a>.box1002:hover {
    color: #2b9a34;
}

.user_pop_view_txt {
    text-align: center;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
}

.pop_view_root {
    position: absolute;
    top: 52px;
    left: 220px;
    width: 710px;
    height: 430px;
    background: #fff;
    display: block;
    z-index: 99999999;
    padding: 2%;
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    overflow-x: hidden;
    overflow-y: auto;
    box-shadow: 0px 0px 11px 1px rgba(161, 150, 150, 0.26);
    transition: all 0.5s;
}

.tanchu_txt1:hover {
    color: #2b9a34;
}

.tanchu_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    float: left;
    text-align: right;
    width: auto;
    line-height: 30px;
    cursor: pointer;
    transition: all 0.5s;
}

.recombination {
    border: 2px solid #2b9a34;
    display: flex;
    position: relative;
}

.classify {
    width: 100px;
    padding: 0 10px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
    margin: 10px 0;
    border-right: 1px solid #d7d7d7;
    display: flex;
    cursor: pointer;
}

.classify>img {
    width: 14px;
    height: 7px;
    position: absolute;
    top: 17px;
    left: 70px;
}

.classify-list {
    width: 100px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px #c9c9c9;
    position: absolute;
    color: #666666;
    top: 50px;
    left: 0;
    z-index: 1000000000;
    line-height: 24px;
    /* padding-bottom: 0; */
    cursor: pointer;

    max-height: 0;
    padding: 0;
    overflow: hidden;
}

.classify-list>div:hover {
    color: #2b9a34;
}

.head_input_icon {
    background: #2b9a34;
    text-align: center;
    line-height: 40px;
    float: left;
    width: 60px;
    height: 40px;
    cursor: pointer;
    font-size: 25px;
}

.show-classify img {
    transform: rotate(180deg);
}

.show-classify .classify-list {
    max-height: 176px;
    padding: 10px 19px;
}

.green {
    color: #2b9a34;
}

.head_input {
    width: 305px;
    height: 40px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    border: 0;
    font-weight: 400;
    color: #666;
    float: left;
    outline: none;
    padding-left: 10px;
}

.gzh_erweima_txt {
    width: 12px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    float: left;
    line-height: 15px;
    margin-left: 5px;
    margin-top: 5px;
}

.catr_num {
    position: absolute;
    text-align: center;
    /* background: #2c9a34; */
    background: red;
    border-radius: 7px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    padding: 2px 5px;
    height: 14px;
    line-height: 10px;
    top: 3px;
    left: 15px;
}

/* .ant-input {
      border: none !important;
outline: none !important;
height: 38px !important;
    } */

.ant-input-search-button {
    background: #2b9a34 !important;
    border: none !important;
    height: 40px;
    width: 60px;
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    padding: 0;
    /* overflow: hidden; */
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
}

body {
    padding: 0 !important;
    margin: 0 !important;
    /* overflow: hidden; */
    width: 100%;
    height: 100%;
    position: relative !important;
}

html,
body,
#app {
    height: 100%;
    padding: 0;
    margin: 0;
}

.box1015:hover.pop_view_root {
    display: block;
}

.gaoliang {
    color: #2b9a34;
}

.user_pop_view_txt:hover {
    color: #2b9a34;
}
</style>



// WEBPACK FOOTER //
// src/public/head.vue